import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "watch",
  "description": "`watch` 명령어에 대한 API 레퍼런스"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "코드 변경 사항을 기반으로 저장소의 태스크를 재실행합니다."
  }, {
    "heading": "",
    "content": "turbo watch는 의존성을 인식하므로 turbo.json에 구성된 순서대로 태스크가 재실행됩니다."
  }, {
    "heading": "",
    "content": "태스크가 제공되지 않으면 turbo는 저장소의 패키지에 사용 가능한 태스크를 표시합니다."
  }, {
    "heading": "persistent-태스크와-함께-turbo-watch-사용하기",
    "content": "Persistent 태스크는 \"persistent\": true로 표시되어 종료되지 않습니다. 따라서 태스크 그래프에서 의존될 수 없습니다."
  }, {
    "heading": "persistent-태스크와-함께-turbo-watch-사용하기",
    "content": "이는 turbo watch를 사용할 때 persistent 태스크가 무시되어 turbo run과 동일한 방식으로 작동하며, persistent 태스크와 non-persistent 태스크를 동시에 실행할 수 있음을 의미합니다."
  }, {
    "heading": "의존성을-인식하는-persistent-태스크",
    "content": "스크립트에 의존성의 변경 사항을 감지할 수 있는 내장 watcher(next dev와 같은)가 있는 경우 turbo watch를 사용할 필요가 없습니다. 대신 스크립트의 내장 watcher를 사용하고 \"persistent\": true를 사용하여 태스크를 장기 실행으로 표시하세요."
  }, {
    "heading": "의존성을-인식하지-않는-persistent-태스크",
    "content": "일부 도구는 모노레포 친화적이지 않으며 의존성의 모듈을 핫 리로드하지 않습니다. 이러한 경우 태스크를 interruptible: true로 표시하여 turbo watch가 관련 변경 사항이 감지될 때 태스크를 재시작하도록 해야 합니다."
  }, {
    "heading": "캐싱",
    "content": "Watch Mode에서 태스크 캐싱은 현재 --experimental-write-cache 플래그에서 실험적입니다."
  }, {
    "heading": "태스크-출력",
    "content": "소스 제어에 체크인된 파일에 쓰는 태스크가 있는 경우 Watch Mode가 무한 루프에서 실행될 가능성이 있습니다. 이는 Watch Mode가 파일의 변경 사항을 감시하고 변경된 패키지의 태스크를 재실행하기 때문입니다. 태스크가 변경 사항을 생성하면 해당 태스크가 다시 트리거됩니다."
  }, {
    "heading": "태스크-출력",
    "content": "Watch Mode에는 파일 해시를 사용하여 이런 일이 발생하지 않도록 하는 로직이 있지만 완벽하지는 않습니다. 이 문제를 피하기 위해 git에서 태스크 출력을 제거하는 것을 권장합니다."
  }],
  "headings": [{
    "id": "persistent-태스크와-함께-turbo-watch-사용하기",
    "content": "persistent 태스크와 함께 turbo watch 사용하기"
  }, {
    "id": "의존성을-인식하는-persistent-태스크",
    "content": "의존성을 인식하는 persistent 태스크"
  }, {
    "id": "의존성을-인식하지-않는-persistent-태스크",
    "content": "의존성을 인식하지 않는 persistent 태스크"
  }, {
    "id": "제한-사항",
    "content": "제한 사항"
  }, {
    "id": "캐싱",
    "content": "캐싱"
  }, {
    "id": "태스크-출력",
    "content": "태스크 출력"
  }]
};
export const toc = [{
  depth: 2,
  url: "#persistent-태스크와-함께-turbo-watch-사용하기",
  title: _jsxs(_Fragment, {
    children: ["persistent 태스크와 함께 ", _jsx("code", {
      children: "turbo watch"
    }), " 사용하기"]
  })
}, {
  depth: 3,
  url: "#의존성을-인식하는-persistent-태스크",
  title: _jsx(_Fragment, {
    children: "의존성을 인식하는 persistent 태스크"
  })
}, {
  depth: 3,
  url: "#의존성을-인식하지-않는-persistent-태스크",
  title: _jsx(_Fragment, {
    children: "의존성을 인식하지 않는 persistent 태스크"
  })
}, {
  depth: 2,
  url: "#제한-사항",
  title: _jsx(_Fragment, {
    children: "제한 사항"
  })
}, {
  depth: 3,
  url: "#캐싱",
  title: _jsx(_Fragment, {
    children: "캐싱"
  })
}, {
  depth: 3,
  url: "#태스크-출력",
  title: _jsx(_Fragment, {
    children: "태스크 출력"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "코드 변경 사항을 기반으로 저장소의 태스크를 재실행합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [tasks]"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo watch"
      }), "는 의존성을 인식하므로 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration",
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), "에 구성된"]
      }), " 순서대로 태스크가 재실행됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["태스크가 제공되지 않으면 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 저장소의 패키지에 사용 가능한 태스크를 표시합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h2, {
      id: "persistent-태스크와-함께-turbo-watch-사용하기",
      children: ["persistent 태스크와 함께 ", _jsx(_components.code, {
        children: "turbo watch"
      }), " 사용하기"]
    }), "\n", _jsxs(_components.p, {
      children: ["Persistent 태스크는 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: _jsx(_components.code, {
          children: "\"persistent\": true"
        })
      }), "로 표시되어 종료되지 않습니다. 따라서 태스크 그래프에서 의존될 수 없습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이는 ", _jsx(_components.code, {
        children: "turbo watch"
      }), "를 사용할 때 persistent 태스크가 무시되어 ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), "과 동일한 방식으로 작동하며, persistent 태스크와 non-persistent 태스크를 동시에 실행할 수 있음을 의미합니다."]
    }), "\n", _jsx(_components.h3, {
      id: "의존성을-인식하는-persistent-태스크",
      children: "의존성을 인식하는 persistent 태스크"
    }), "\n", _jsxs(_components.p, {
      children: ["스크립트에 의존성의 변경 사항을 감지할 수 있는 내장 watcher(", _jsx(_components.code, {
        children: "next dev"
      }), "와 같은)가 있는 경우 ", _jsx(_components.code, {
        children: "turbo watch"
      }), "를 사용할 필요가 없습니다. 대신 스크립트의 내장 watcher를 사용하고 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: _jsx(_components.code, {
          children: "\"persistent\": true"
        })
      }), "를 사용하여 태스크를 장기 실행으로 표시하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "의존성을-인식하지-않는-persistent-태스크",
      children: "의존성을 인식하지 않는 persistent 태스크"
    }), "\n", _jsxs(_components.p, {
      children: ["일부 도구는 모노레포 친화적이지 않으며 의존성의 모듈을 핫 리로드하지 않습니다. 이러한 경우 태스크를 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#interruptible",
        children: _jsx(_components.code, {
          children: "interruptible: true"
        })
      }), "로 표시하여 ", _jsx(_components.code, {
        children: "turbo watch"
      }), "가 관련 변경 사항이 감지될 때 태스크를 재시작하도록 해야 합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "제한-사항",
      children: "제한 사항"
    }), "\n", _jsx(_components.h3, {
      id: "캐싱",
      children: "캐싱"
    }), "\n", _jsxs(_components.p, {
      children: ["Watch Mode에서 태스크 캐싱은 현재 ", _jsx(_components.code, {
        children: "--experimental-write-cache"
      }), " 플래그에서 실험적입니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " your-tasks"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --experimental-write-cache"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "태스크-출력",
      children: "태스크 출력"
    }), "\n", _jsx(_components.p, {
      children: "소스 제어에 체크인된 파일에 쓰는 태스크가 있는 경우 Watch Mode가 무한 루프에서 실행될 가능성이 있습니다. 이는 Watch Mode가 파일의 변경 사항을 감시하고 변경된 패키지의 태스크를 재실행하기 때문입니다. 태스크가 변경 사항을 생성하면 해당 태스크가 다시 트리거됩니다."
    }), "\n", _jsx(_components.p, {
      children: "Watch Mode에는 파일 해시를 사용하여 이런 일이 발생하지 않도록 하는 로직이 있지만 완벽하지는 않습니다. 이 문제를 피하기 위해 git에서 태스크 출력을 제거하는 것을 권장합니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
